<template>
  <div class="wrapper">
    <div class="animated fadeIn">
        <div class="serviceVoucher-edit">
          <b-row class="my-4">
            <b-col class="text-right">
              <b-button type="submit" variant="success" @click="submit">
                <i class="fa fa-dot-circle-o"></i> Save
              </b-button>
              <b-button type="reset" variant="danger" to="/service-vouchers">
                <i class="fa fa-ban"></i> Cancel
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6" xl="5">
              <b-card>
                <div slot="header">
                  <div class="text-center">
                    Service Voucher <br>
                    <strong>{{ service.service_datetime | moment("dddd, Do MMMM YYYY") }}</strong>
                  </div>
                </div>
                <div class="my-4">
                  <b-row>
                    <b-col md="6">
                      <v-input-date
                        name="AddServiceVoucherModal__date"
                        v-model="service.service_datetime"
                        :required="true"
                        :v="$v.service['service_datetime']"
                        @blur="$v.service['service_datetime'].$touch()"
                        @focus="$v.service['service_datetime'].$reset()"
                        label="Service Date"></v-input-date>
                    </b-col>
                    <b-col md="6">
                      <v-input-time
                        name="AddServiceVoucherModal__time"
                        v-model="service.service_datetime"
                        :required="true"
                        :v="$v.service['service_datetime']"
                        @blur="$v.service['service_datetime'].$touch()"
                        @focus="$v.service['service_datetime'].$reset()"
                        label="Time"></v-input-time>
                    </b-col>
                  </b-row>
                </div>
                <div class="my-4">
                  <draggable class="dragArea" :class="(service.bookings.length) ? '' : 'no-items'" v-model="service.bookings" :options="{group:'bookings', handle: '.serviceVoucher__card__handle'}" :move="onMoveCallback">
                    <transition-group name="serviceVoucher__cards" tag="div">
                      <service-voucher-booking-card v-for="(booking, key) in service.bookings" :booking="booking" :key="key" :index="(key + 1)"></service-voucher-booking-card>
                    </transition-group>
                  </draggable>
                </div>
              </b-card>
            </b-col>
            <b-col cols="6" xl="7">
              <b-card>
                <div slot="header">
                  <div class="text-center">
                    Bookings
                  </div>
                  <div class="card-actions">
                    <a @click="showFilters = !showFilters" :class="(showFilters) ? 'text-primary' : 'text-muted'">
                      <i class="fa fa-search fa-lg"></i>
                    </a>
                  </div>
                </div>
                <add-bookings-to-service-voucher ref="bookingList" :showFilters="showFilters"></add-bookings-to-service-voucher>
              </b-card>
            </b-col>
          </b-row>
        </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import 'es6-promise/auto'
import AddBookingsToServiceVoucher from './AddBookingsToServiceVoucher'
import ServiceVoucherBookingCard from './ServiceVoucherBookingCard'
import {serviceVoucherServices} from '../../services/index'
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'

export default {
  name: 'ServiceVoucherEdit',
  props: ['id'],
  data () {
    return {
      isBusy: false,
      showFilters: false,
      showModal: true,
      service: {
        bookings: []
      }
    }
  },
  methods: {
    onMoveCallback (evt, originalEvent) {
      // debugger
    },
    show () {
      let xhr = this.$store.dispatch('serviceVouchers/show', this.id)

      xhr.then(
        (res) => {
          this.service = {
            ...res.data.data
          }
        }
      )
    },
    test () {
      serviceVoucherServices.addBooking(this.id, 5)
    },
    getLocationNameById (locationId) {
      let location = this.locationById(locationId)
      return (location) ? location.name : ''
    },
    submit () {
      let payload = {...this.service}
      delete payload.created_at
      delete payload.updated_at
      payload.bookings = payload.bookings.map((booking) => {
        return booking.id
      })

      this.isBusy = true

      let xhr = this.$store.dispatch('serviceVouchers/update', payload)
      xhr.then(
        this.handleUpdateSuccess,
        this.handleUpdateFail
      )
    },
    handleUpdateSuccess () {
      this.isBusy = false
      this.$refs.bookingList.bookingProvider()
    },
    handleUpdateFail () {
      this.isBusy = false
    }
  },
  computed: {
    ...mapGetters(
      'locations',
      [
        'locationById'
      ]
    )
  },
  watch: {
    id () {
      this.show()
    }
  },
  created () {
    this.show()
    this.$store.dispatch('locations/index')
  },
  validations: {
    service: {
      service_datetime: {
        required
      }
    }
  },
  components: {
    AddBookingsToServiceVoucher,
    ServiceVoucherBookingCard,
    draggable
  }
}
</script>

<style lang="scss">
  .serviceVoucher__card {
    transition: all 1s;
    .card-body {
      padding: 0;

      .card-actions {
        border: 0;
        a {
          border: 0;
          cursor: pointer;
        }
      }
    }
  }

  .serviceVoucher__cards {
    &-enter, &-leave-to, &-leave-active {
      opacity: 0;
      transform: translateX(-30px);
    }
  }

  .dragArea {
    &.no-items {
      & > div {
        padding: 24px;
        border: 2px dashed #dedede;
        border-radius: 4px;
        color: #dedede;
        &:before {
          content: 'Add booking to service voucher by draging it and dropping it in this area';
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/serviceVouchers/Edit.vue